import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'mt-alert',
    templateUrl: './alert.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AlertComponent implements OnInit {
  @Input() title: string;
  @Input() variant: string = 'primary';
  @Input() disabled: boolean = false;
  @Output() onAction = new EventEmitter<any>();
  @Input() buttons: any = [
    { label: 'Ok', class: '', submit: true }
  ];
  constructor() { }

  ngOnInit() {
  }

  onClickAction($event: any) {
    this.disabled = true;
    this.onAction.emit($event);
  }
}
